// import Service from '../Service'
import AuthService from "../AuthService";
import Auth from "./auth.service";

const FormRF = {
  saveRF04_1(data) {
    return AuthService.post("/api/adverse-drug-event", data).then((res) => res);
  },
  saveEditRF04_1(data) {
    return AuthService.get("/api/save-edit-view-form-rf04_1?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveEditRFSusar(data) {
    var reportdatedata
    if (data.researcherReportDate.date) {
      reportdatedata = data.researcherReportDate.date;
    } else {
      reportdatedata = data.researcherReportDate;
    }
    return AuthService.get("/api/save-edit-view-form-susar?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + reportdatedata).then((res) => res);
  },
  saveRF04_2(data) {
    return AuthService.post("/api/adverse-event", data).then((res) => res);
  },
  saveEditRF04_2(data) {
    return AuthService.get("/api/save-edit-view-form-rf04_2?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveRF06(data) {
    return AuthService.post("/api/research-summarize", data).then((res) => res);
  },
  saveEditRF06(data) {
    return AuthService.get("/api/save-edit-view-form-rf06?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveRF12(data) {
    return AuthService.post("/api/research-amendment", data).then((res) => res);
  },
  saveEditRF12(data) {
    return AuthService.get("/api/save-edit-view-form-rf12?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveRF03(data) {
    return AuthService.post("/api/progress-report", data).then((res) => res);
  },
  saveEditRF03(data) {
    return AuthService.get("/api/save-edit-view-form-rf03?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveRF05(data) {
    return AuthService.post("/api/deviation-report", data).then((res) => res);
  },
  saveEditRF05(data) {
    return AuthService.get("/api/save-edit-view-form-rf05?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  saveRF07(data) {
    let formData = new FormData();
    formData.append("researchID", data.researchID);
    formData.append("researchName", data.researchName);
    formData.append("researchCode", data.researchCode);
    formData.append("researchInvestor", data.researchInvestor);
    formData.append("mainResearcher", data.mainResearcher);
    formData.append("phoneNumber", data.phoneNumber);
    formData.append("email", data.email);
    formData.append("firstDate", data.firstDate);
    formData.append("lastDate", data.lastDate);
    formData.append("startDate", data.startDate);
    formData.append("endDate", data.endDate);
    formData.append("hasIssue", data.hasIssue);
    formData.append("hasWarning", data.hasWarning);
    formData.append("reason", data.reason);
    formData.append("hasFollowUp", data.hasFollowUp);
    formData.append("followUp", data.followUp);
    formData.append("hasPlan", data.hasPlan);
    formData.append("plan", data.plan);
    formData.append("resultFile", data.resultFile);
    formData.append("signature", data.signature);
    formData.append("reportDate", data.reportDate);
    return AuthService.post("/api/research-termination", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  saveEditRF07(data) {
    return AuthService.get("/api/save-edit-view-form-rf07?researchID=" + data.researchID + "&noteDetail=" + data.noteDetail + "&rfID=" + data.rfID + "&researcherReportDate=" + data.researcherReportDate).then((res) => res);
  },
  getRF12(id) {
    return AuthService.get(`/api/research-amendment/${id}`).then((res) => res);
  },
  getRF05(id) {
    return AuthService.get(`/api/deviation-report/${id}`).then((res) => res);
  },
  getDeviationReportByIdResearch(id) {
    return AuthService.get(`/api/get-deviation-report-by-id/${id}`).then(
      (res) => res
    );
  },
  getRFSusar(id) {
    return AuthService.get(`/api/research-susar/${id}`).then(res => res)
  },
  getRF03(id) {
    return AuthService.get(`/api/progress-report/${id}`).then((res) => res);
  },
  getRF04_1(id) {
    return AuthService.get(`/api/adverse-drug-event/${id}`).then((res) => res);
  },
  getRF04_2(id) {
    return AuthService.get(`/api/adverse-event/${id}`).then((res) => res);
  },
  getRF06(id) {
    return AuthService.get(`/api/research-summarize/${id}`).then((res) => res);
  },
  getRF07(id) {
    return AuthService.get(`/api/research-termination/${id}`).then(
      (res) => res
    );
  },
  getCorres(id) {
    return AuthService.get(`/api/correspondence/${id}`).then(
      (res) => res
    );
  },
  getRF(data) {
    console.log("serv", data);
    return AuthService.get(
      `/api/show-paginate-rf?page=` + data.page + "&filter=" + data.filter + "&researcherName=" + data.researcherName + "&researchCode=" + data.researchCode
    ).then((res) => res);
  },
  getDocumentResearch(data) {
    return AuthService.get(`/api/get-document-research?page=` + data.page + "&filter=" + data.filter + "&researchID="+ data.id).then((res) => res);
  },
  getRFAll(data) {
    return AuthService.get(
      `/api/show-paginate-all-rf?page=` + data.page + "&filter=" + data.filter + "&researcherName=" + data.researcherName + "&researchCode=" + data.researchCode
    ).then((res) => res);
  },
  checkRF(data) {
    return AuthService.put(`/api/check-rf`, data).then((res) => res);
  },
  deleteRF(data) {
    return AuthService.post(`/api/delete-rf`, data).then((res) => res);
  },
  ApproveRF(data) {
    return AuthService.post(`/api/rf-approve`, data).then((res) => res);
  },
  updateStatusRF(data) {
    console.log("TEXT", data);
    let formData = new FormData();
    formData.append("id", data.id);
    formData.append("name", data.name);
    formData.append("filter", data.filter);
    formData.append("status", data.status);
    formData.append("note", data.note);
    formData.append("approveDate", data.approveDate);
    formData.append("month", data.month);
    formData.append("otherMonth", data.otherMonth);
    formData.append("considerationType", data.considerationType);
    formData.append("researchID", data.researchID);
    formData.append("file", data.file);
    return AuthService.post(`/api/update-rf-result`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => res);
  },
  updateStatusRF2(data) {
    return AuthService.post(`/api/update-rf-result`, data).then((res) => res);
  },
};

export default FormRF;
